import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';
import api from '../../utils/api';
import {
  Box,
  CircularProgress,
  Typography,
  styled,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../Hooks/useConfig';
import { setCookie } from '../../utils/cookies';
import { Helmet } from 'react-helmet-async';
const PleaseWaitContent = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.secondary.neutral_30 : theme.palette.secondary.neutral_90}`,
  width: '450px',
  padding: '1rem',
  textAlign: 'center',
  borderRadius: theme.spacing(2),
  margin: 'auto',
  backgroundColor: theme.palette.secondary.paper,
  [theme.breakpoints.down('sm')]: {
    width: '95%',
  },
}));
const CenterBox = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
const Callback = () => {
  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const { t } = useTranslation();
  const { panelUrl, baseDomain, token } = useConfig();
  const project = panelUrl.includes(window.location.hostname)
    ? 'panel'
    : 'playground';

  const getAccessTokenAuth = async () => {
    const callbackApi = await api.call({
      name: 'accessTokenCallback',
      queryParam: `${params.id}/${project}/callback${location.search}`,
    });
    if (callbackApi.status === 200) {
      setCookie(
        'token',
        callbackApi.data.data.token,
        callbackApi.data.data.expires_in,
        baseDomain
      );
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'loginComplete',
      });
      if (localStorage.getItem('redirectUrl')) {
        history.push(
          '/' + localStorage.getItem('redirectUrl').replace('?redirect=', '')
        );
        localStorage.removeItem('redirectUrl');
      } else {
        history.push('/');
      }
    } else {
      history.push('/login');
    }
  };
  useEffect(() => {
    if (token) {
      history.push('/');
    } else {
      getAccessTokenAuth();
    }
  }, []);
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <CenterBox>
        <PleaseWaitContent>
          <Typography sx={{ fontSize: '20px', fontWeight: 500, mb: 4 }}>
            {t('layout_playground.please_wait')}
          </Typography>
          <Typography
            sx={{
              color: theme.palette.mode === 'dark' ? '#C8C5CA' : '#5F5E62',
              mb: 4,
              lineHeight: 2.2,
            }}
          >
            {t('layout_playground.please_wait_text_first')} <br />{' '}
            {t('layout_playground.please_wait_text_second')}
          </Typography>
          <CircularProgress color={'primary'} />
        </PleaseWaitContent>
      </CenterBox>
    </>
  );
};
export default Callback;
